module.exports = "img/flags/TG.4278556.png";